import { Injectable, EventEmitter } from "@angular/core";

import {
  SignalRService,
  SignalREventService,
  ToastrService,
  Minesite,
  Company,
  CompanyMinesites,
  MinesiteUsers,
  MinesiteEquipment,
  MinesiteCompanies,
  User,
  Equipment,
  DataArray,
  GlobalService,
  EquipmentService,
} from "./../index";

@Injectable()
export class MinesiteService {
  public minesitesChange: EventEmitter<Minesite[]> = new EventEmitter<
    Minesite[]
  >();
  public minesiteChange: EventEmitter<Minesite> = new EventEmitter<Minesite>();
  public companyMinesiteChanges: EventEmitter<CompanyMinesites> =
    new EventEmitter<CompanyMinesites>();
  public minesiteUsersChange: EventEmitter<MinesiteUsers> =
    new EventEmitter<MinesiteUsers>();
  public minesiteCompaniesChange: EventEmitter<MinesiteCompanies> =
    new EventEmitter<MinesiteCompanies>();
  public minesiteEquipmentChange: EventEmitter<MinesiteEquipment> =
    new EventEmitter<MinesiteEquipment>();
  public showEditChange: EventEmitter<Minesite> = new EventEmitter<Minesite>();
  public showDetailChange: EventEmitter<Minesite> =
    new EventEmitter<Minesite>();

  public minesites: DataArray<Minesite> = new DataArray<Minesite>();

  private name = "";
  private activeMinesites = true;
  private inActiveMinesites = true;
  private live = true;
  private selectedModels: number[] = [];
  private selectedEquipment: number[] = [];
  private selectedPoweredBys: number[] = [];
  private selectedClassifications: number[] = [];
  constructor(
    private _signalRService: SignalRService,
    private _signalREventService: SignalREventService,
    private _toastrService: ToastrService,
    private _GlobalService: GlobalService,
    private _equipmentService: EquipmentService
  ) {
    this.minesites.init();
    this.registerOnServerEvents();
  }

  public getMinesites(): void {
    this._signalRService.invoke("GetMinesites");
  }
  public getMinesitesStaging(): void {
    this._signalRService.invoke("getMinesitesStaging");
  }

  public getMinesitesForCompany(companyId: number): void {
    this.live = true;
    if (companyId) {
      this._signalRService.invoke("GetMinesitesForCompany", companyId);
    }
  }
  // staging environment changes
  public getMinesitesForCompanyStaging(companyId: number): void {
    this.live = false;
    if (companyId) {
      this._signalRService.invoke("getMinesitesForCompanyStaging", companyId);
    }
  }
  public removeAssociation(companyId: number, minesiteId: number) {
    this._signalRService
      .invoke("LockStagingTab", Number(localStorage.getItem("User_ID")))
      .then((result: any) => {
        if (result != null) {
          if (result.IsNew) {
            this._toastrService.displayToastrMessage(
              "success",
              "Staging environment is locked successfully",
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
            this.live = false;
            this._signalRService.invoke(
              "RemoveMinesiteAssociation",
              companyId,
              minesiteId,
              Number(localStorage.getItem("User_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy == Number(localStorage.getItem("User_ID"))
          ) {
            this.live = false;
            this._signalRService.invoke(
              "RemoveMinesiteAssociation",
              companyId,
              minesiteId,
              Number(localStorage.getItem("User_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy != Number(localStorage.getItem("User_ID"))
          ) {
            this._toastrService.displayToastrMessage(
              "error",
              result.Note,
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
          }
        }
      });
  }
  public create(minesite: Minesite, live: boolean): void {
    this._signalRService
      .invoke("LockStagingTab", Number(localStorage.getItem("User_ID")))
      .then((result: any) => {
        if (result != null) {
          if (result.IsNew) {
            this._toastrService.displayToastrMessage(
              "success",
              "Staging environment is locked successfully",
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
            this.live = false;
            this._signalRService.invoke(
              "CreateMinesite",
              minesite.Name,
              live,
              Number(localStorage.getItem("User_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy == Number(localStorage.getItem("User_ID"))
          ) {
            this.live = false;
            this._signalRService.invoke(
              "CreateMinesite",
              minesite.Name,
              live,
              Number(localStorage.getItem("User_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy != Number(localStorage.getItem("User_ID"))
          ) {
            this._toastrService.displayToastrMessage(
              "error",
              result.Note,
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
          }
        }
      });
  }
  public update(minesite: Minesite): void {
    this._signalRService
      .invoke("LockStagingTab", Number(localStorage.getItem("User_ID")))
      .then((result: any) => {
        if (result != null) {
          if (result.IsNew) {
            this._toastrService.displayToastrMessage(
              "success",
              "Staging environment is locked successfully",
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
            this.live = false;
            this._signalRService.invoke(
              "UpdateMinesite",
              minesite.Minesite_ID,
              minesite.Name,
              minesite.Active,
              Number(localStorage.getItem("User_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy == Number(localStorage.getItem("User_ID"))
          ) {
            this.live = false;
            this._signalRService.invoke(
              "UpdateMinesite",
              minesite.Minesite_ID,
              minesite.Name,
              minesite.Active,
              Number(localStorage.getItem("User_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy != Number(localStorage.getItem("User_ID"))
          ) {
            this._toastrService.displayToastrMessage(
              "error",
              result.Note,
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
          }
        }
      });
  }
  public edit(minesite: Minesite): void {
    this.showEditChange.emit(minesite);
  }
  public delete(minesiteId: number): void {
    this._signalRService
      .invoke("LockStagingTab", Number(localStorage.getItem("User_ID")))
      .then((result: any) => {
        if (result != null) {
          if (result.IsNew) {
            this._toastrService.displayToastrMessage(
              "success",
              "Staging environment is locked successfully",
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
            this.live = false;
            this._signalRService.invoke(
              "DeleteMinesite",
              minesiteId,
              Number(localStorage.getItem("User_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy == Number(localStorage.getItem("User_ID"))
          ) {
            this.live = false;
            this._signalRService.invoke(
              "DeleteMinesite",
              minesiteId,
              Number(localStorage.getItem("User_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy != Number(localStorage.getItem("User_ID"))
          ) {
            this._toastrService.displayToastrMessage(
              "error",
              result.Note,
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
          }
        }
      });
  }
  public showDetails(minesite: Minesite, Live: boolean): void {
    this.live = Live;
    if (Live) {
      //calling method in equipment service, should not be invoked separately from separate services
      //this._signalRService.invoke("GetEquipmentForMinesite", minesite.Id);
      this._equipmentService.getEquipmentForMinesite(minesite.Id);
    } else {
      //calling method in equipment service, should not be invoked separately from separate services
      //this._signalRService.invoke("getEquipmentForMinesiteStaging",minesite.Minesite_ID);
      this._equipmentService.getEquipmentForMinesiteStaging(
        minesite.Minesite_ID
      );
    }
    this._signalRService.invoke(
      "GetUsersForMinesite",
      Live ? minesite.Id : minesite.Minesite_ID,
      Live
    );
    this._signalRService.invoke(
      "GetCompaniesForMinesite",
      Live ? minesite.Id : minesite.Minesite_ID,
      Live
    );

    this.showDetailChange.emit(minesite);
  }
  public applyFilter(
    name: string,
    activeMinesites: boolean,
    inActiveMinesites: boolean,
    live: boolean,
    selectedModels: number[],
    selectedEquipment: number[],
    selectedPoweredBys: number[],
    selectedClassifications: number[]
  ): void {
    this.name = name;
    this.activeMinesites = activeMinesites;
    this.inActiveMinesites = inActiveMinesites;
    this.selectedModels = selectedModels;
    this.selectedEquipment = selectedEquipment;
    this.selectedPoweredBys = selectedPoweredBys;
    this.selectedClassifications = selectedClassifications;
    this.live = live;
    this._signalRService.invoke(
      "FilterMinesites",
      this.name,
      this.activeMinesites,
      this.inActiveMinesites,
      this.live,
      this.selectedModels,
      this.selectedEquipment,
      this.selectedPoweredBys,
      this.selectedClassifications
    );
  }
  public getFilteredMinesites(): void {
    this._signalRService.invoke(
      "FilterMinesites",
      this.name,
      this.activeMinesites,
      this.inActiveMinesites,
      this.selectedModels,
      this.selectedEquipment,
      this.selectedPoweredBys,
      this.selectedClassifications
    );
  }
  private onMinesites(info: any): void {
    for (const item of info.Data.Minesites) {
      const minesite: Minesite = $.extend(new Minesite(), item);
      this.minesites.push(minesite);
    }
    this.minesitesChange.emit(this.minesites.Data);
  }
  private onCompanyMinesites(info: any): void {
    const companyMinesites: CompanyMinesites = new CompanyMinesites();
    const companyMinesitesList: DataArray<Minesite> = new DataArray<Minesite>();
    for (const item of info.Data.Minesites) {
      const minesite: Minesite = $.extend(new Minesite(), item);
      companyMinesitesList.update(minesite, true);
    }
    companyMinesites.CompanyId = info.Data.CompanyId;
    companyMinesites.Minesites = companyMinesitesList.Data;
    this.companyMinesiteChanges.emit(companyMinesites);
  }
  private onUpdateMinesite(info: any): void {
    this._toastrService.displayToastrMessage(
      "success",
      "Minesite has been updated!",
      "Update Minesite"
    );
    const minesite: Minesite = $.extend(new Minesite(), info.Data.Minesite);
    this.minesites.update(minesite);
    this.minesiteChange.emit(minesite);

    this._signalRService.invoke("getMinesitesStaging");
  }
  private onCreateMinesite(info: any): void {
    const minesite: Minesite = $.extend(new Minesite(), info.Data.Minesite);
    this.minesites.unshift(minesite);
    this.minesiteChange.emit(minesite);
  }
  private onDeleteMinesite(info: any): void {
    this._toastrService.displayToastrMessage(
      "success",
      "Minesite " + info.Name + " has been deleted!",
      "Delete Minesite"
    );
    const minesite: Minesite = $.extend(new Minesite(), info);
    this.minesites.update(minesite);
    this.minesiteChange.emit(minesite);
    //this._signalRService.invoke("-");
    this._signalRService.invoke("getMinesitesStaging");
    this._signalRService.invoke(
      "getMinesitesForCompanyStaging",
      minesite.Companies[0].Company_ID
    );
  }
  private onRemoveMinesiteAssociation(info: any): void {
    this._toastrService.displayToastrMessage(
      "success",
      "Minesite " +
        info.Data.Minesite.Name +
        " no longer associated with company " +
        info.Data.Company.Name +
        ".",
      "Remove Minesite Association"
    );
    this.getMinesitesForCompanyStaging(info.Data.Company.Id);
  }
  private onMinesiteUsers(info: any): void {
    const minesiteUsers: MinesiteUsers = new MinesiteUsers();
    minesiteUsers.MinesiteId = info.Data.CompanyId;
    for (const user of info.Data.Users) {
      minesiteUsers.Users.push($.extend(new User(), user));
    }
    this.minesiteUsersChange.emit(minesiteUsers);
  }
  private onMinesiteCompanies(info: any): void {
    const minesiteCompanies: MinesiteCompanies = new MinesiteCompanies();
    minesiteCompanies.MinesiteId = info.Data.MinesiteId;
    for (const company of info.Data.Companies) {
      minesiteCompanies.Companies.push($.extend(new Company(), company));
    }
    this.minesiteCompaniesChange.emit(minesiteCompanies);
  }
  private onMinesiteEquipment(info: any): void {
    const minesiteEquipment: MinesiteEquipment = new MinesiteEquipment();
    minesiteEquipment.MinesiteId = info.Data.MinesiteId;
    for (const equipment of info.Data.Equipment) {
      minesiteEquipment.Equipment.push($.extend(new Equipment(), equipment));
    }
    this.minesiteEquipmentChange.emit(minesiteEquipment);
  }
  private registerOnServerEvents() {
    this._signalREventService.register(
      "MinesiteService",
      "minesites",
      (info: any) => this.onMinesites(info)
    );
    this._signalREventService.register(
      "MinesiteService",
      "beginRecieveMinesites",
      () => {
        this.minesites.init();
      }
    );
    this._signalREventService.register(
      "MinesiteService",
      "createMinesite",
      (info: any) => this.onCreateMinesite(info)
    );
    this._signalREventService.register(
      "MinesiteService",
      "updateminesite",
      (info: any) => this.onUpdateMinesite(info)
    );
    this._signalREventService.register(
      "MinesiteService",
      "deleteMinesite",
      (info: any) => this.onDeleteMinesite(info)
    );
    this._signalREventService.register(
      "MinesiteService",
      "removeMinesiteAssociation",
      (info: any) => this.onRemoveMinesiteAssociation(info)
    );
    this._signalREventService.register(
      "MinesiteService",
      "companyMinesites",
      (info: any) => this.onCompanyMinesites(info)
    );
    this._signalREventService.register(
      "MinesiteService",
      "minesiteCompanies",
      (info: any) => this.onMinesiteCompanies(info)
    );
    this._signalREventService.register(
      "MinesiteService",
      "minesiteEquipment",
      (info: any) => this.onMinesiteEquipment(info)
    );
    this._signalREventService.register(
      "MinesiteService",
      "minesiteUsers",
      (info: any) => this.onMinesiteUsers(info)
    );
  }
  public deregisterOnServerEvents(): void {
    this._signalREventService.deregister("MinesiteService");
  }
}
